import { equipmentStatusesSlice } from "./equipmentStatusesSlice";
import * as actions from "./equipmentStatusesActions";
import * as selectors from "./equipmentStatusesSelectors";

export { actions };
export { selectors };
export default equipmentStatusesSlice.reducer;
